<template>
  <div>
    <el-table
      v-if="bills.length"
      :data="bills"
      border
      style="width: 100%"
      row-key="invoice_id"
    >
      <el-table-column
        prop="invoice_number"
        label="Bill Number"
        width="150"
      />
      <el-table-column
        prop="date"
        label="Date"
        width="120"
        :formatter="format_date"
      />
      <el-table-column
        prop="due_date"
        label="Due Date"
        width="120"
        :formatter="format_date"
      />
      <el-table-column
        prop="status"
        label="Status"
        width="100"
      />
      <el-table-column
        prop="total"
        label="Total"
        width="120"
      />
      <el-table-column
        prop="amount_due"
        label="Outstanding"
        width="120"
      />
    </el-table>

    <div v-else>
      <p>No bills to display.</p>
    </div>
  </div>
</template>

<script>
import { xero_bills } from '../../api/xero';

export default {
  name: 'XeroBills',
  props: { contact: { type: Object, required: true } },
  data() {
    return { bills: [], loading: false };
  },
  mounted() {
    this.fetch_bills();
  },
  methods: {
    async fetch_bills() {
      if (!this.contact) return;
      this.loading = true;
      try {
        const response = await xero_bills(this, { contact_id: this.contact.contact_id });
        this.bills = response.data.bills || [];
      } catch (err) {
        console.error('Failed to fetch Xero bills', err);
      } finally {
        this.loading = false;
      }
    },
    format_date(row, column, cellValue) {
      if (typeof cellValue === 'string') {
        const match = /\/Date\((\d+)([+-]\d+)?\)\//.exec(cellValue);
        if (match) {
          return new Date(parseInt(match[1], 10)).toLocaleDateString();
        }
      }
      return cellValue || '';
    }
  }
};
</script>
